import { render, staticRenderFns } from "./SupportContactsBottomSheet.vue?vue&type=template&id=55f14ad8"
import script from "./SupportContactsBottomSheet.vue?vue&type=script&lang=ts"
export * from "./SupportContactsBottomSheet.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseBottomSheet: require('/builds/medtochka/medtochka-frontend/core/components/Base/BaseBottomSheet.vue').default})
